import styled from 'styled-components';

export const ModalHeader = styled.div`
    position: relative;
    z-index: var(--z-index-modal-header);
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: var(--modal-border-radius) var(--modal-border-radius) 0 0;

    background: var(--container-background-color-100);
    box-shadow: var(--container-shadow-color-100);
    padding: var(--modal-padding);
`;
